"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const paymentStatus_1 = __importDefault(require("../../clients/booking/paymentStatus"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const PAYMENT_STATUS_1 = __importDefault(require("../../constants/payment/PAYMENT_STATUS"));
const PAYMENT_TYPE_1 = __importDefault(require("../../constants/payment/PAYMENT_TYPE"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Payment Status Check Domain Store
 * Will be called by 3d secure payment flow
 */
class PaymentStatusStore {
    constructor(initialState) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Makes payment status api call
         * Will be called by 3d secure payment flow
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (
        // reqParam: PaymentStatusParamType,
        quoteId, successHandler, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const reqParam = {
                    paymentType: PAYMENT_TYPE_1.default.CHECKOUT,
                    referenceNo: quoteId,
                };
                console.log('Payment status reqParam: ', reqParam);
                const response = yield (0, paymentStatus_1.default)(reqParam);
                // 200 http codes
                this.onSuccess(response, successHandler);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data, successHandler) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
            if (successHandler) {
                successHandler(data); // passes the response object back
            }
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns payment status
     * @returns {string}
     */
    get paymentStatus() {
        return (0, get_1.default)(this.data, 'status', '');
    }
    /**
     * Returns last 4 digits card no
     * @returns {string}
     */
    get paymentCardNo() {
        return (0, get_1.default)(this.data, 'card', '');
    }
    /**
     * Returns payment card type
     * eg. Visa, Mastercard
     * @returns {string}
     */
    get paymentCardType() {
        return (0, get_1.default)(this.data, 'scheme', '');
    }
    /**
     * Payment has failed if:
     *  API call has given 400 or non 200 status
     *  API call is 200 but payment status was failed or TIMED_OUT
     */
    get hasPaymentFailed() {
        return (this.hasFailed ||
            this.paymentStatus === PAYMENT_STATUS_1.default.FAILED ||
            this.paymentStatus === PAYMENT_STATUS_1.default.TIMED_OUT);
    }
    /**
     * Payment is success if
     *  API call was success 200 And
     *  status=SUCCESS
     * @returns {boolean}
     */
    get isPaymentSuccess() {
        return this.isSuccess && this.paymentStatus === PAYMENT_STATUS_1.default.SUCCESS;
    }
    /**
     * Get ReferenceNo
     * @returns {string}
     */
    get paymentStatusReferenceNo() {
        return (0, get_1.default)(this.data, 'bookingReferenceNo', '');
    }
}
__decorate([
    mobx_1.observable
], PaymentStatusStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], PaymentStatusStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], PaymentStatusStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "paymentStatus", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "paymentCardNo", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "paymentCardType", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "hasPaymentFailed", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "isPaymentSuccess", null);
__decorate([
    mobx_1.computed
], PaymentStatusStore.prototype, "paymentStatusReferenceNo", null);
__decorate([
    mobx_1.action.bound
], PaymentStatusStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], PaymentStatusStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], PaymentStatusStore.prototype, "updateInitialState", void 0);
exports.default = PaymentStatusStore;
